import React, { useState, useEffect } from 'react';
import {fetchUsers, generateAccessCode, updateUserByAdmin} from '../../api/api';
import styles from './AdminUsersForm.module.css';
import CustomModal from "../../UI/Modal/CustomModal";
import Spinner from "../Spinner/Spinner";

const AdminUsersForm = () => {
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalAction, setModalAction] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [emailFilter, setEmailFilter] = useState('');
    const [firstNameFilter, setFirstNameFilter] = useState('');
    const [lastNameFilterState, setLastNameFilterState] = useState('');
    const [phoneFilter, setPhoneFilter] = useState('');



    const getUsers = async () => {
        try {
            const fetchedUsers = await fetchUsers();
            if (Array.isArray(fetchedUsers)) {
                setUsers(fetchedUsers);
            } else {
                console.error('Fetched data is not an array:', fetchedUsers);
                setUsers([]); // Ustaw pustą tablicę, aby uniknąć błędów
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        }finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getUsers();
    }, []);


    const filteredUsers = users.filter(user => {
        const emailMatch = user.username.toLowerCase().includes(emailFilter.toLowerCase());
        const firstNameMatch = user.firstName.toLowerCase().includes(firstNameFilter.toLowerCase());
        const lastNameMatch = user.lastName.toLowerCase().includes(lastNameFilterState.toLowerCase());
        const phoneMatch = user.phone?.toLowerCase().includes(phoneFilter.toLowerCase());
        return emailMatch && firstNameMatch && lastNameMatch && phoneMatch;
    });



    const handleReservationToggle = async (id, enabledReservation, lastName) => {
        setModalAction(() => () => updateUserByAdmin(id, { enabledReservation: !enabledReservation }));
        setShowModal(true);
        setLastName(lastName);
    };

    const handleMembershipToggle = async (id, isMember, lastName) => {
        setModalAction(() => () => updateUserByAdmin(id, { isMember: !isMember }));
        setShowModal(true);
        setLastName(lastName);
    };

    const handleCoachshipToggle = async (id, isCoach, lastName) => {
        setModalAction(() => () => updateUserByAdmin(id, { isCoach: !isCoach }));
        setShowModal(true);
        setLastName(lastName);
    };

    const handleDateChange = async (id, newDate) => {
        try {
            await updateUserByAdmin(id, { payedToDate: newDate || null });
            getUsers();
        } catch (error) {
            console.error('Błąd podczas aktualizacji daty płatności użytkownika.', error);
        }
    };


    const confirmModalAction = async () => {
        setShowModal(false);
        try {
            await modalAction();
            getUsers();
        } catch (error) {
            console.error('Błąd podczas wykonywania akcji modalu.', error);
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setLastName(null);
    };

    if (isLoading) return <Spinner size={"large"}/>;

    return (
        <>
            <CustomModal
                isOpen={showModal}
                onRequestClose={closeModal}
                message={`Czy na pewno chcesz wykonać tę akcję na ${lastName} ?`}
                confirmLabel="Wykonaj"
                onConfirm={confirmModalAction}
                confirmButtonColor="green"
                cancelLabel="Anuluj"
                cancelButtonColor="red"
                onCancel={closeModal}
            />

            <div className={styles.filterContainer}>
                <input
                    type="text"
                    placeholder="Email"
                    className={styles.filterInput}
                    value={emailFilter}
                    onChange={(e) => setEmailFilter(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Imię"
                    className={styles.filterInput}
                    value={firstNameFilter}
                    onChange={(e) => setFirstNameFilter(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Nazwisko"
                    className={styles.filterInput}
                    value={lastNameFilterState}
                    onChange={(e) => setLastNameFilterState(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Telefon"
                    className={styles.filterInput}
                    value={phoneFilter}
                    onChange={(e) => setPhoneFilter(e.target.value)}
                />
            </div>

            <div className={styles.superAdmin}>
                <table className={styles.table}>
                    <thead>
                    <tr>
                        <th>Email</th>
                        <th>Telefon</th>
                        <th>Imię</th>
                        <th>Nazwisko</th>
                        <th>Rez</th>
                        <th>BTT</th>
                        <th>Coach</th>
                        <th>Okres</th>
                        <th>Kod</th>

                    </tr>
                    </thead>
                    <tbody>
                    {filteredUsers
                        .sort((a, b) => a.lastName.localeCompare(b.lastName))
                        .map((user) => (
                            <tr key={user.id}>
                                <td>{user.username}</td>
                                <td>{user.phone}</td>
                                <td>{user.firstName}</td>
                                <td>{user.lastName}</td>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={user.enabledReservation}
                                        onChange={() => handleReservationToggle(user.id, user.enabledReservation, user.lastName)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={user.member}
                                        onChange={() => handleMembershipToggle(user.id, user.member, user.lastName)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={user.coach}
                                        onChange={() => handleCoachshipToggle(user.id, user.coach, user.lastName)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="date"
                                        value={user.payedToDate ? user.payedToDate : ""}
                                        onChange={(event) => handleDateChange(user.id, event.target.value)}
                                    />
                                </td>
                                <td>
                                    <div className={styles.code}>
                                        <span>{user.doorAccessCode || "-"}</span>
                                        <button
                                            className={styles.button}
                                            onClick={async () => {
                                                try {
                                                    await generateAccessCode(user.id);
                                                    getUsers(); // odśwież listę użytkowników
                                                } catch (error) {
                                                    alert("Błąd podczas generowania kodu.");
                                                }
                                            }}
                                            style={{ padding: '4px 8px' }}
                                        >
                                            gen
                                        </button>

                                    </div>
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>

    );

};

export default AdminUsersForm;
